import { render, staticRenderFns } from "./AlertTable.global.vue?vue&type=template&id=5efef178&scoped=true&lang=pug&"
import script from "./AlertTable.global.vue?vue&type=script&lang=ts&"
export * from "./AlertTable.global.vue?vue&type=script&lang=ts&"
import style0 from "./AlertTable.global.vue?vue&type=style&index=0&id=5efef178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efef178",
  null
  
)

export default component.exports